export const defaultSlippage = 0.005;
